export default __webpack_public_path__ + "static/media/IMG_6035 copie.0aec4ee1.jpg";